/**
 * 붙은 상자 — 같은 목록을 **걸러 보는** 단추 묶음 한 벌 (v2.252.0 · 화면 통일 ①).
 *
 * 세부 탭(PageTabs · 화면을 바꾼다)과 모양을 다르게 둬서 「이건 거르기」임이 보이게 한다.
 *   예) 내 결재함 「🖐️ 내 승인 대기 · 진행 중 · 전체 · 상태별」 · 딜등록 「진행 중 · 종료 · ✉ 정보 요청」 ·
 *       관급 「MAS · 3자단가」 · 세금계산서 「발행요청 이력 · 수신·처리 내역」 · 설문 「집계 · 명단」.
 *
 *   · 높이 30px · 13px · 켜진 것 = 진한 회색 채움. `tone='warn'`(황색) 은 「처리할 것이 쌓이는 칸」(정보 요청)에만.
 *   · `value` 가 null 이면 아무것도 안 켜진다(상태 필터를 다 푼 상태).
 *   · 접근성: role=group + button[aria-pressed]. ⚠영업진행 진행단계 단추도 aria-pressed 를 쓴다 — 그물은 글자로 찾는다.
 */

import type { ReactNode } from 'react';

export type SegmentOption<K extends string> = {
  key: K;
  label: ReactNode;
  /** 작은 건수 */
  count?: number;
  title?: string;
  /** 켜졌을 때 색 — 기본 진한 회색 · warn 황색 · info 파랑 */
  tone?: 'default' | 'warn' | 'info';
  hidden?: boolean;
  /** 지금은 고를 수 없는 칸(메일 찾기 「보낸 사람」처럼) — 흐리게 · title 로 까닭을 적는다 */
  disabled?: boolean;
};

export function SegmentedControl<K extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}: {
  options: readonly SegmentOption<K>[];
  value: K | null;
  onChange: (key: K) => void;
  ariaLabel: string;
  className?: string;
}) {
  return (
    <div role="group" aria-label={ariaLabel} className={`ui-seg ${className ?? ''}`}>
      {options.filter((o) => !o.hidden).map((o) => {
        const on = o.key === value;
        return (
          <button
            key={o.key}
            type="button"
            aria-pressed={on}
            data-tone={o.tone ?? 'default'}
            title={o.title}
            disabled={o.disabled}
            onClick={() => onChange(o.key)}
            className="ui-seg-item"
          >
            {o.label}
            {o.count !== undefined && <span className="ui-seg-count">{o.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
